import React from 'react';

const Testimonials = () => {
    const testimonials = [
        {
            quote: "Azúcar Multimedia transformed our digital presence with amazing and functional design.",
            author: "Maria González",
            position: "CEO, Company X"
        },
        {
            quote: "The team exceeded our expectations with their creativity and professionalism.",
            author: "Juan Pérez",
            position: "Marketing Director, Company Y"
        },
        {
            quote: "The results of the digital marketing campaign were exceptional. 100% recommended!",
            author: "Ana Martínez",
            position: "Sales Manager, Business Z"
        }
    ];

    return (
        <section className="py-20 bg-gradient-to-r from-red-50 to-cyan-50">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">What Our Clients Say</h2>
                    <div className="w-20 h-1 bg-red-600 mx-auto"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300"
                        >
                            <div className="text-red-600 text-4xl mb-4">"</div>
                            <p className="text-gray-600 italic mb-6">{testimonial.quote}</p>
                            <div className="border-t border-gray-200 pt-4">
                                <p className="font-bold text-gray-800">{testimonial.author}</p>
                                <p className="text-gray-500 text-sm">{testimonial.position}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;